import { useLayoutEffect, useState } from 'react';

export const useMatchMedia = (mediaQuery) => {
  const matchMedia =
    typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined'
      ? window.matchMedia
      : undefined;

  const supportedQuery = mediaQuery.replace(/^@media( ?)/m, '');

  const [matches, setMatches] = useState(() =>
    matchMedia ? matchMedia(supportedQuery).matches : undefined
  );
  const screenTest = ({ matches }) => setMatches(matches);

  useLayoutEffect(() => {
    if (!matchMedia) {
      return undefined;
    }

    const mql = matchMedia(supportedQuery);
    mql.addListener(screenTest);

    return () => {
      mql.removeListener(screenTest);
    };
  }, [matchMedia, supportedQuery]);

  return matches;
};
